import useStoreLocatorStyles from './StoreLocator.styles';
import { IStoreLocatorResultCardProps } from './StoreLocator.types';
import { Radio } from '@fluentui/react-components';

const StoreLocatorResultCard = (props: IStoreLocatorResultCardProps) => {
    const { result, groupName, selected, onChange } = props;

    const styles = useStoreLocatorStyles();

    return (
        <div
            className={`${selected ? styles.selectedResultCard : styles.resultCardRoot}`}
            onClick={() => onChange(result.name)}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === 'Space') onChange(result.name);
            }}
        >
            <div className={styles.resultCardContentWrapper}>
                <Radio
                    name={groupName}
                    value={result.name}
                    label={result.name}
                    checked={selected}
                    className={styles.radioButton}
                />

                <div className={styles.resultCardAddress}>
                    <div>{result.address.addressLine1}</div>

                    <div>
                        {result.address.city}, {result.address.state} {result.address.zipcode}
                    </div>

                    <div>{result.distanceInMiles} miles away</div>
                </div>
            </div>
        </div>
    );
};

export default StoreLocatorResultCard;
